<div [formGroup]="form">

  <!-- Identificação -->
  <div class="p-fluid grid config-section">
    <div class="col-12">
      <h6 class="subsection-title">Ambiente</h6>
      <p class="section-description">Dê um nome à conexão e escolha em qual ambiente ela será usada.</p>
    </div>
    <div class="field col-12 md:col-6">
      <p-floatLabel>
        <input
          pInputText
          id="nomeConexao"
          formControlName="nomeConexao"
          [class.ng-invalid]="campoInvalido('nomeConexao')"
          [class.ng-dirty]="campoInvalido('nomeConexao')"
        />
        <label for="nomeConexao">Nome da Conexão *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('nomeConexao')">
        Nome da conexão é obrigatório (mínimo 3 caracteres)
      </small>
      <small class="p-text-secondary">Ex.: API de pedidos — produção.</small>
    </div>

    <div class="field col-12 md:col-6">
      <p-floatLabel>
        <input
          pInputText
          id="ambiente"
          formControlName="ambiente"
          placeholder="Ex: Produção, Desenvolvimento, Homologação"
          [class.ng-invalid]="campoInvalido('ambiente')"
          [class.ng-dirty]="campoInvalido('ambiente')"
        />
        <label for="ambiente">Ambiente *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('ambiente')">
        Ambiente é obrigatório
      </small>
      <small class="p-text-secondary">Ex.: Produção, Homologação ou Desenvolvimento.</small>
    </div>

    <div class="field col-12 md:col-6">
      <div class="field-checkbox">
        <p-checkbox
          inputId="padrao"
          formControlName="padrao"
          [binary]="true"
        ></p-checkbox>
        <label for="padrao">Marcar como conexão padrão</label>
      </div>
      <small class="p-text-secondary">Informativo: a execução usa a conexão escolhida em cada comando.</small>
    </div>

    <div class="field col-12 md:col-6" *ngIf="modoEdicao">
      <div class="field-checkbox">
        <p-inputSwitch inputId="ativo" formControlName="ativo"></p-inputSwitch>
        <label for="ativo">Conexão ativa</label>
      </div>
      <small class="p-text-secondary">
        Informativo: hoje inativar uma conexão não impede a execução dos comandos que a usam.
      </small>
    </div>
  </div>

  <!-- Campos específicos para API REST -->
  <div *ngIf="api" class="p-fluid grid config-section">
    <div class="col-12">
      <h6 class="subsection-title">Configuração de API REST</h6>
      <p class="section-description">Informe o endereço principal; as rotas específicas são cadastradas depois.</p>
    </div>

    <div class="field col-12">
      <p-floatLabel>
        <input
          pInputText
          id="urlBase"
          formControlName="urlBase"
          placeholder="https://api.exemplo.com/v1"
          [class.ng-invalid]="campoInvalido('urlBase')"
          [class.ng-dirty]="campoInvalido('urlBase')"
        />
        <label for="urlBase">URL Base da API *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('urlBase')">
        Informe uma URL válida iniciando com http:// ou https://
      </small>
      <small class="p-text-secondary">
        Endereço principal da API. Cada rota cadastrada depois será acrescentada a ele.
      </small>
    </div>

    <div class="col-12">
      <h6 class="subsection-title subheading">Tempo de espera e novas tentativas</h6>
      <p class="section-description">Defina quanto tempo esperar por uma resposta e o que fazer se a chamada falhar.</p>
    </div>

    <div class="field col-12 md:col-4">
      <p-floatLabel>
        <p-inputNumber
          id="timeout"
          formControlName="timeout"
          suffix=" ms"
          [min]="1000"
          [max]="300000"
          [step]="1000"
          [useGrouping]="false"
          [class.ng-invalid]="campoInvalido('timeout')"
          [class.ng-dirty]="campoInvalido('timeout')"
        ></p-inputNumber>
        <label for="timeout">Tempo máximo de espera (ms) *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('timeout')">
        Timeout é obrigatório (mínimo 1000 ms)
      </small>
      <small class="p-text-secondary">1000 ms = 1 segundo. A chamada falha quando esse tempo acaba.</small>
    </div>

    <div class="field col-12 md:col-4">
      <p-floatLabel>
        <p-inputNumber
          id="retry_tentativas"
          formControlName="retry_tentativas"
          [min]="0"
          [max]="10"
          [useGrouping]="false"
        ></p-inputNumber>
        <label for="retry_tentativas">Novas tentativas após falha</label>
      </p-floatLabel>
      <small class="p-text-secondary">Use 0 para não tentar novamente.</small>
    </div>

    <div class="field col-12 md:col-4">
      <p-floatLabel>
        <p-inputNumber
          id="retry_intervalo"
          formControlName="retry_intervalo"
          suffix=" ms"
          [min]="100"
          [max]="10000"
          [step]="100"
          [useGrouping]="false"
        ></p-inputNumber>
        <label for="retry_intervalo">Espera entre tentativas (ms)</label>
      </p-floatLabel>
      <small class="p-text-secondary">A espera aumenta a cada tentativa: intervalo × número da tentativa.</small>
    </div>
  </div>

  <!-- Campos específicos para Banco de Dados -->
  <div *ngIf="!api" class="p-fluid grid config-section">
    <div class="col-12">
      <h6 class="subsection-title">Configuração de Banco de Dados</h6>
      <p class="section-description">Use os dados de acesso informados pelo administrador do banco.</p>
    </div>

    <div class="field col-12 md:col-6">
      <p-floatLabel>
        <p-dropdown
          id="tipo_bd"
          formControlName="tipo_bd"
          [options]="tiposBancoDados"
          optionLabel="label"
          optionValue="value"
          optionDisabled="disabled"
          appendTo="body"
          [style]="{'width':'100%'}"
        ></p-dropdown>
        <label for="tipo_bd">Tipo de Banco de Dados *</label>
      </p-floatLabel>
      <small class="p-text-secondary">Somente Oracle é suportado atualmente.</small>
    </div>

    <div class="field col-12 md:col-6">
      <p-floatLabel>
        <input
          pInputText
          id="host"
          formControlName="host"
          placeholder="localhost ou 192.168.1.100"
          [class.ng-invalid]="campoInvalido('host')"
          [class.ng-dirty]="campoInvalido('host')"
        />
        <label for="host">Host *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('host')">
        Host é obrigatório
      </small>
    </div>

    <div class="field col-12 md:col-6">
      <p-floatLabel>
        <p-inputNumber
          id="porta"
          formControlName="porta"
          [min]="1"
          [max]="65535"
          [useGrouping]="false"
          [class.ng-invalid]="campoInvalido('porta')"
          [class.ng-dirty]="campoInvalido('porta')"
        ></p-inputNumber>
        <label for="porta">Porta *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('porta')">
        Porta é obrigatória (1-65535)
      </small>
    </div>

    <div class="field col-12 md:col-6">
      <p-floatLabel>
        <input
          pInputText
          id="database"
          formControlName="database"
          [class.ng-invalid]="campoInvalido('database')"
          [class.ng-dirty]="campoInvalido('database')"
        />
        <label for="database">Nome do Banco / Service *</label>
      </p-floatLabel>
      <small class="p-error" *ngIf="campoInvalido('database')">
        Nome do banco de dados é obrigatório
      </small>
    </div>

    <div class="col-12">
      <p-fieldset legend="Avançado" [toggleable]="true" [collapsed]="true">
        <div class="field">
          <p-floatLabel>
            <input
              pInputText
              id="driverClass"
              formControlName="driverClass"
              placeholder="oracle.jdbc.OracleDriver"
            />
            <label for="driverClass">Driver Class</label>
          </p-floatLabel>
          <small class="p-text-secondary">
            Opcional. Sobrescreve a detecção automática do driver.
          </small>
        </div>
      </p-fieldset>
    </div>
  </div>

  <!-- Credenciais -->
  <div class="p-fluid grid config-section">
    <div class="col-12">
      <h6 class="subsection-title">Credenciais de acesso</h6>
      <p class="section-description">Escolha como esta conexão se autentica. As credenciais serão guardadas com segurança.</p>
    </div>

    <!-- Edição: mostra a credencial atual (os valores nunca são devolvidos) e permite substituí-la -->
    <ng-container *ngIf="modoEdicao">
      <div class="col-12">
        <div class="info-message">
          <i class="pi pi-lock"></i>
          <span>
            Credencial atual: <strong>{{ rotuloCredencialAtual }}</strong>. Os valores gravados nunca são exibidos.
            <ng-container *ngIf="!tipoCredencialAtual && !api">
              <strong>Atenção:</strong> uma conexão de banco sem credencial não executa; informe usuário e senha.
            </ng-container>
          </span>
        </div>
      </div>

      <div class="field col-12">
        <div class="field-checkbox">
          <p-inputSwitch inputId="alterarCredencial" formControlName="alterarCredencial"></p-inputSwitch>
          <label for="alterarCredencial">Alterar credencial</label>
        </div>
        <small class="p-text-secondary">
          A credencial gravada é substituída por inteiro: informe todos os campos, não só o que mudou.
        </small>
      </div>
    </ng-container>

    <ng-container *ngIf="editorCredencialVisivel">
      <div class="field col-12">
        <p-floatLabel>
          <p-dropdown
            id="tipoCredencial"
            formControlName="tipoCredencial"
            [options]="opcoesCredencial"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [style]="{'width':'100%'}"
          ></p-dropdown>
          <label for="tipoCredencial">Tipo de Credencial *</label>
        </p-floatLabel>
      </div>

      <!-- DATABASE -->
      <ng-container *ngIf="tipoCredencialForm === TipoCredencial.DATABASE">
        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="cred_user"
              formControlName="cred_user"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_user')"
              [class.ng-dirty]="campoInvalido('cred_user')"
            />
            <label for="cred_user">Usuário do Banco *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_user')">
            Usuário é obrigatório
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              type="password"
              id="cred_password"
              formControlName="cred_password"
              autocomplete="new-password"
              [class.ng-invalid]="campoInvalido('cred_password')"
              [class.ng-dirty]="campoInvalido('cred_password')"
            />
            <label for="cred_password">Senha do Banco *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_password')">
            Senha é obrigatória
          </small>
        </div>
      </ng-container>

      <!-- BEARER -->
      <ng-container *ngIf="tipoCredencialForm === TipoCredencial.BEARER">
        <div class="field col-12">
          <p-floatLabel>
            <textarea
              pInputTextarea
              id="cred_token"
              formControlName="cred_token"
              rows="3"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_token')"
              [class.ng-dirty]="campoInvalido('cred_token')"
            ></textarea>
            <label for="cred_token">Bearer Token *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_token')">
            Token é obrigatório
          </small>
        </div>
      </ng-container>

      <!-- SEM_CREDENCIAL -->
      <ng-container *ngIf="tipoCredencialForm === TipoCredencial.SEM_CREDENCIAL">
        <div class="col-12">
          <div class="info-message">
            <i class="pi pi-info-circle"></i>
            <span>
              <ng-container *ngIf="!modoEdicao">Nenhuma credencial será gravada.</ng-container>
              <ng-container *ngIf="modoEdicao">A credencial atual será removida.</ng-container>
              A API é chamada sem token estático. Para APIs com login (ex.: JWT), use um recurso de
              Autenticação no processo: o token é obtido em tempo de execução.
            </span>
          </div>
        </div>
      </ng-container>

      <div class="col-12" *ngIf="tipoCredencialForm !== TipoCredencial.SEM_CREDENCIAL">
        <small class="p-text-secondary">
          As credenciais são criptografadas e nunca são exibidas novamente.
        </small>
      </div>
    </ng-container>
  </div>
</div>
